import styled from "styled-components";

import { StatusColorIndicator } from "./DataView/StatusCell";

const InlineStatusColorIndicator = styled(StatusColorIndicator)`
  display: inline-block;
  vertical-align: middle;
`;

export default InlineStatusColorIndicator;
